"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classcat = _interopRequireDefault(require("classcat"));

var _MonthView = _interopRequireDefault(require("./MonthView"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
const ignoreWeekDays = [3, // Wen
6, // Sat
7 // Sun
];
const now = new Date();

const genYears = nowYear => {
  const years = [];

  for (let i = -7; i < 5; i++) {
    years.push(nowYear + i);
  }

  return years;
};

const years = genYears(now.getFullYear());

const Header = _styledComponents.default.div.withConfig({
  displayName: "Calendar__Header",
  componentId: "sc-1a3yf79-0"
})(["display:flex;justify-content:center;width:100%;h1{cursor:pointer;font-weight:300;margin:0;padding:16px;", ";border:1px solid transparent;border-bottom:0;margin-bottom:-1px;&.selected{background:#fff;border-color:#eee;position:relative;}&:hover:not(.selected){background:#eee;}}"], p => p.theme.transition);

const Grid = _styledComponents.default.div.withConfig({
  displayName: "Calendar__Grid",
  componentId: "sc-1a3yf79-1"
})(["ul{background:#fff;border:1px solid #dfdfdf;display:flex;flex-wrap:wrap;height:320px;padding:8px;width:640px;}li{align-items:center;cursor:pointer;display:flex;flex:1 1 160px;justify-content:center;", ";&.selected{background:", ";color:#fff;}&:hover:not(.selected){background:#eee;}}"], p => p.theme.transition, p => p.theme.colors.main);

class Calendar extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      month: now.getMonth() + 1,
      year: now.getFullYear(),
      show: '',
      selectedDates: []
    });

    _defineProperty(this, "toggle", show => () => {
      this.setState(prevState => {
        if (prevState.show === show) {
          return {
            show: ''
          };
        }

        return {
          show: showSelector
        };
      });
    });

    _defineProperty(this, "selectMonth", month => () => {
      this.setState(() => ({
        month,
        show: ''
      }));
    });

    _defineProperty(this, "isSelectedMonth", idx => {
      const {
        month
      } = this.state;
      return month === idx;
    });

    _defineProperty(this, "selectYear", year => () => {
      this.setState(() => ({
        year,
        show: ''
      }));
    });

    _defineProperty(this, "isSelectedYear", idx => {
      const {
        year
      } = this.state;
      return year === idx;
    });

    _defineProperty(this, "handleDaySelect", dateToHandle => {
      this.setState(prevState => {
        if (prevState.selectedDates.includes(dateToHandle)) {
          return {
            selectedDates: prevState.selectedDates.filter(selectedDate => {
              return selectedDate !== dateToHandle;
            })
          };
        }

        const selectedDates = [...prevState.selectedDates, dateToHandle];
        selectedDates.sort();
        return {
          selectedDates
        };
      });
    });

    _defineProperty(this, "getSelectedDays", (days, selectedDates) => {
      return days.filter(day => selectedDates.includes(day.value)).map(day => day.value);
    });

    _defineProperty(this, "handleWeekSelect", days => {
      this.setState(prevState => {
        const selectedDays = this.getSelectedDays(days, prevState.selectedDates);

        if (selectedDays.length) {
          return {
            selectedDates: prevState.selectedDates.filter(selectedDate => {
              return !selectedDays.includes(selectedDate);
            })
          };
        }

        const daysValues = days.map(day => day.value).filter(day => !ignoreWeekDays.includes(new Date(day).getDay() || 7));
        const selectedDates = [...prevState.selectedDates, ...daysValues];
        selectedDates.sort();
        return {
          selectedDates
        };
      });
    });

    _defineProperty(this, "renderMonths", () => {
      return /*#__PURE__*/_react.default.createElement(Grid, null, /*#__PURE__*/_react.default.createElement("ul", null, monthNames.map((month, idx) => /*#__PURE__*/_react.default.createElement("li", {
        key: month,
        className: (0, _classcat.default)({
          selected: this.isSelectedMonth(idx + 1)
        }),
        onClick: this.selectMonth(idx + 1)
      }, month))));
    });

    _defineProperty(this, "renderYears", () => /*#__PURE__*/_react.default.createElement(Grid, null, /*#__PURE__*/_react.default.createElement("ul", null, years.map(year => /*#__PURE__*/_react.default.createElement("li", {
      key: year,
      className: (0, _classcat.default)({
        selected: this.isSelectedYear(year)
      }),
      onClick: this.selectYear(year)
    }, year)))));
  }

  render() {
    const {
      className
    } = this.props;
    const {
      month,
      year,
      show,
      selectedDates
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement("h1", {
      className: (0, _classcat.default)({
        selected: show === 'months'
      }),
      onClick: this.toggle('months')
    }, monthNames[month - 1]), /*#__PURE__*/_react.default.createElement("h1", {
      className: (0, _classcat.default)({
        selected: show === 'years'
      }),
      onClick: this.toggle('years')
    }, year)), show === 'months' && this.renderMonths(), show === 'years' && this.renderYears(), !show && /*#__PURE__*/_react.default.createElement(_MonthView.default, {
      month: month,
      year: year,
      select: selectedDates,
      onSelectDay: this.handleDaySelect,
      onSelectWeek: this.handleWeekSelect
    }));
  }

}

var _default = (0, _styledComponents.default)(Calendar).withConfig({
  displayName: "Calendar",
  componentId: "sc-1a3yf79-2"
})(["display:flex;flex-direction:column;align-items:center;"]);

exports.default = _default;